import React from "react";
import { Sparkles, LayoutDashboard, Briefcase, History as HistoryIcon, Settings } from "lucide-react";
import type { View } from "../../types";
import PWAInstallButton from "../PWAInstallButton";

interface SidebarProps {
    view: View;
    setView: (view: View) => void;
    setIsSettingsOpen: (isOpen: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ view, setView, setIsSettingsOpen }) => {
    const navItems = [
        { id: "dashboard", icon: LayoutDashboard, label: "Dashboard" },
        { id: "brand", icon: Briefcase, label: "Brand Voice" },
        { id: "history", icon: HistoryIcon, label: "History" },
    ];

    return (
        <aside className="hidden md:flex w-64 border-r border-white/5 bg-white/[0.02] backdrop-blur-xl flex-col p-4 z-20 sticky top-0 h-screen">
            <div className="flex items-center gap-3 px-2 mb-10">
                <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center shadow-lg shadow-primary/20">
                    <Sparkles className="text-white" size={24} />
                </div>
                <span className="hidden md:block font-bold text-xl tracking-tight bg-gradient-to-r from-white to-white/60 bg-clip-text text-transparent px-1">
                    InstaCommenter
                </span>
            </div>

            <nav className="flex-1 space-y-2">
                {navItems.map((item) => (
                    <button
                        key={item.id}
                        onClick={() => setView(item.id as View)}
                        className={`w-full flex items-center gap-3 px-3 py-3 rounded-2xl transition-all ${view === item.id
                            ? "bg-primary text-white shadow-lg shadow-primary/20"
                            : "text-white/40 hover:bg-white/5 hover:text-white"
                            }`}
                    >
                        <item.icon size={20} />
                        <span className="hidden md:block font-medium">{item.label}</span>
                    </button>
                ))}
            </nav>

            <div className="pt-4 mt-4 border-t border-white/5 space-y-2">
                <PWAInstallButton className="w-full" />
                <button
                    onClick={() => setIsSettingsOpen(true)}
                    className="w-full flex items-center gap-3 px-3 py-3 rounded-2xl text-white/40 hover:bg-white/5 hover:text-white transition-all"
                >
                    <Settings size={20} />
                    <span className="hidden md:block font-medium">Settings</span>
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
